/* Makers Art Studio — rebooted primary navigation.
   One clear IA organized by INTENT (Experiences · Celebrations · Camps · Locations),
   replacing the old medium-by-medium dropdown sprawl.
   Reads window.MAKERS_LOC (set per page) so Danville & Pleasanton stay in sync
   while showing only what each studio actually offers. */
(function () {
  const L = window.MAKERS_LOC || {};
  const base = L.base;                       // e.g. https://danville.makersartstudio.com
  const P = (slug) => `${base}/products/${slug}`;
  const PG = (slug) => `${base}/pages/${slug}`;
  const bday = L.birthday;                    // local birthday page href
  const team = L.team || "Team Building - Makers Hi-Fi.html";
  const tumbler = L.tumblerSlug || "resin-tumbler-experience";
  const masterpiece = L.masterpieceSlug || "the-masterpiece-series";
  // Experiences hub — a collection/page that exists on BOTH stores. Used for the
  // "see all experiences" link and as the Book Now destination on pages that have
  // no #experiences section to scroll to. L.hubHref wins when set (Pleasanton), else
  // falls back to /collections/art-experiences (200 on both; NOT /collections/experiences
  // which 404s everywhere).
  const hub = L.hubHref || (base + '/collections/art-experiences');

  // ── Experiences columns ──
  const paint = [
    { n: "Fluid Art", d: "Pour, swirl & keep your canvas", href: P("fluid-art-experience") },
    { n: "The Masterpiece Series", d: "Oversize statement canvases", href: L.masterpieceHref || P(masterpiece) },
  ];
  if (L.glow) paint.push({ n: "Glow in the Dark", d: "UV pours under blacklight", href: L.glowHref || P("glow-in-the-dark-fluid-art"), tag: "Danville only", tagCls: "glow" });

  const resin = [
    { n: "Resin Beach Scene", d: "Layered ocean waves", href: P("resin-beach-scene") },
    { n: "Tumbler Lab", d: "Design a tumbler you'll use", href: P(tumbler) },
    { n: "Resin Mosaic Frames", d: "Meditative tile mosaics", href: P("resin-mosaic-frames") },
    { n: "Artful Boards & Coasters", d: "Resin boards & coasters", href: P("charcuterie-boards-wine-glasses-coasters") },
  ];

  const glass = [
    { n: "Glass Painting", d: "Bold, backlit designs", href: P("glass-painting") },
    { n: "Deco Dream", d: "3D decoden gems & charms", href: P("decoden-art-workshops") },
    { n: "Patch Party", d: "Custom iron-on patches", href: P("patch-party-hat-experience") },
  ];
  if (L.candle) glass.push({ n: "Candle Studio & Scent Bar", d: "Blend a scent, pour a candle", href: L.candleHref || P("candle-scent-bar-experience"), tag: "New", tagCls: "new" });

  // ── event-intent links (promoted straight to the top bar, approach #3) ──
  const g = L.guides || {};
  // The Bookeasy-published Events page: every upcoming dated session in one
  // listing, kept current by Bookeasy itself. L.eventsHref is the Liquid-resolved
  // page URL (empty on a store without that page), so fall back to the handle and
  // then to the experiences hub rather than emitting a link to nowhere.
  const events = L.eventsHref || (base + '/pages/events') || hub;

  const col = (title, items, cls) => `
    <div class="mm-col ${cls || ''}">
      <div class="mm-h">${title}</div>
      <ul class="mm-list">
        ${items.map(i => `
          <li><a href="${i.href}">
            <span class="mm-n">${i.n}${i.tag ? `<span class="mm-tag ${i.tagCls || ''}">${i.tag}</span>` : ''}</span>
            <span class="mm-d">${i.d}</span>
          </a></li>`).join('')}
      </ul>
    </div>`;

  const featExp = L.candle
    ? { flag: "🕯️ New in Pleasanton", h: "Candle Studio & Scent Bar", p: "Blend a signature scent, then pour a candle to take home.", cta: "Visit the Candle Bar →", href: L.candleHref || "#candle", cls: "candle" }
    : { flag: "✦ Only in Danville", h: "Glow in the Dark", p: "UV fluid art revealed under blacklight — a Danville exclusive.", cta: "See Glow →", href: L.glowHref || "#glow", cls: "glow" };

  const expPanel = `
    ${col("Paint &amp; Pour", paint)}
    ${col("Resin &amp; 3D", resin)}
    ${col("Glass &amp; More", glass)}
    <a class="mm-feature ${featExp.cls}" href="${featExp.href}">
      <span class="mm-flag">${featExp.flag}</span>
      <span class="mm-fh">${featExp.h}</span>
      <span class="mm-fp">${featExp.p}</span>
      <span class="mm-fcta">${featExp.cta}</span>
    </a>
    <div class="mm-foot">
      <span class="mm-foot-lbl">New to this? Start by exploring —</span>
      <a href="${g.thingsToDo || hub}">Things to do in ${L.name}</a>
      <a class="all" href="${hub}">See all experiences &amp; prices →</a>
    </div>`;

  // Locations dropdown (simple)
  const locPanel = `
    <div class="mm-col wide">
      <div class="mm-h">Our studios</div>
      <ul class="mm-list">
        <li><a href="https://danville.makersartstudio.com"><span class="mm-n">Danville${L.name === 'Danville' ? '<span class="mm-tag here">You&rsquo;re here</span>' : ''}</span><span class="mm-d">Home of Glow in the Dark · San Ramon · Alamo · Blackhawk</span></a></li>
        <li><a href="https://pleasanton.makersartstudio.com"><span class="mm-n">Pleasanton${L.name === 'Pleasanton' ? '<span class="mm-tag here">You&rsquo;re here</span>' : ''}</span><span class="mm-d">New Candle Studio &amp; Scent Bar · Dublin · Livermore</span></a></li>
      </ul>
    </div>`;

  const root = document.getElementById('site-menu');
  root.innerHTML = `
    <div class="mm-bar">
      <a class="brand" href="${base || '/'}" aria-label="Makers Art Studio ${L.name} — home">
        <span class="mark"><img src="https://cdn.shopify.com/s/files/1/0951/2861/7256/files/LOGO-01_Medium_ec317985-99a6-406a-9ed7-7b09bd588fd8.jpg?v=1776918883" alt="Makers Art Studio logo" /></span>
        <span class="bt"><span class="b1">MAKERS ART STUDIO</span><span class="b2">${L.name}</span></span>
      </a>
      <nav class="mm-nav" aria-label="Primary">
        <div class="mm-item" data-panel="exp">
          <button class="mm-top" aria-expanded="false" aria-haspopup="true">Experiences <span class="mm-caret">▾</span></button>
          <div class="mm-panel" role="menu"><div class="mm-panel-in">${expPanel}</div></div>
        </div>
        <a class="mm-top link" href="${bday}">Birthdays</a>
        <a class="mm-top link" href="${events}">Events</a>
        <a class="mm-top link" href="${team}">Team Building</a>
        <a class="mm-top link" href="${L.campsHref || (base + '/collections/kids-camps-after-school')}">Camps</a>
        <div class="mm-item" data-panel="loc">
          <button class="mm-top" aria-expanded="false" aria-haspopup="true">Locations <span class="mm-caret">▾</span></button>
          <div class="mm-panel narrow" role="menu"><div class="mm-panel-in loc">${locPanel}</div></div>
        </div>
      </nav>
      <div class="mm-right">
        <span class="mm-native"></span>
        <a class="mm-book" href="${hub}">Book Now →</a>
        <button class="mm-burger" aria-label="Menu" aria-expanded="false">☰</button>
      </div>
    </div>`;

  // ── interactions ──
  const items = [...root.querySelectorAll('.mm-item')];
  let openItem = null;
  function close(it) {
    if (!it) return;
    it.classList.remove('open');
    it.querySelector('.mm-top').setAttribute('aria-expanded', 'false');
  }
  function open(it) {
    if (openItem && openItem !== it) close(openItem);
    it.classList.add('open');
    it.querySelector('.mm-top').setAttribute('aria-expanded', 'true');
    openItem = it;
  }
  items.forEach(it => {
    const btn = it.querySelector('.mm-top');
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      it.classList.contains('open') ? close(it) : open(it);
    });
    // hover open on desktop (pointer); close is DELAYED so the cursor can
    // cross the 12px gap between trigger and panel without dismissing it
    it.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(min-width:981px)').matches) return;
      clearTimeout(it._closeTimer);
      open(it);
    });
    it.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(min-width:981px)').matches) return;
      clearTimeout(it._closeTimer);
      it._closeTimer = setTimeout(() => close(it), 220);
    });
  });
  document.addEventListener('click', (e) => { if (!root.contains(e.target)) close(openItem); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(openItem); });
  // close panel when a link inside is clicked (in-page anchors)
  root.querySelectorAll('.mm-panel a').forEach(a => a.addEventListener('click', () => close(openItem)));

  // mobile burger toggles the whole nav open
  const burger = root.querySelector('.mm-burger');
  burger.addEventListener('click', () => {
    const on = root.classList.toggle('mobile-open');
    burger.setAttribute('aria-expanded', on);
  });

  // Book Now: if THIS page has the experiences grid, smooth-scroll to it; otherwise
  // let the anchor navigate to `hub` (a real collection/page). Previously it always
  // pointed at #experiences, which only exists on local-landing / candle-bar pages —
  // so on the homepage, product, collection & cart pages it was a dead click.
  const bookBtn = root.querySelector('.mm-book');
  if (bookBtn) {
    bookBtn.addEventListener('click', (e) => {
      const target = document.getElementById('experiences');
      if (target) {
        e.preventDefault();
        root.classList.remove('mobile-open');
        burger.setAttribute('aria-expanded', 'false');
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  // Preserve dynamic functionality: move the theme's real (Liquid-rendered) search /
  // account / cart / localization icons into the new bar instead of decorative ones.
  const native = document.getElementById('mas-native-actions');
  const slot = root.querySelector('.mm-native');
  if (native && slot) { while (native.firstChild) slot.appendChild(native.firstChild); native.remove(); }
})();
